/* Glycol chiller hub — collection template v2. Picker, accordion, sticky bar, capture, GA4.
   Reuses collection-hub-howdy-v2.css (generic hb-collection-v2-* classes). */
(function(){
  'use strict';
  var root = document.querySelector('.hb-collection-v2');
  if (!root) return;

  var WEBPRICE_HTML = '<span class="hb-collection-v2-webprice">'
    + '<span class="hb-collection-v2-webprice-label">Web Price</span>'
    + '<button type="button" class="hb-collection-v2-webprice-q" aria-label="Why &ldquo;Web Price&rdquo;?">?</button>'
    + '<span class="hb-collection-v2-webprice-tip" role="tooltip">'
    + '<span class="hb-collection-v2-webprice-tip-text">This is the manufacturer&rsquo;s Minimum Advertised Price (MAP). Want a better price? Request a custom quote &mdash; our team can unlock exclusive pricing, volume discounts, and project rates reserved for direct requests. Free and no obligation.</span>'
    + '<button type="button" class="hb-collection-v2-webprice-tip-link" data-open-quote>Request an unadvertised deal &rsaquo;</button>'
    + '</span></span>';

  var DEFAULT_IMG = 'https://cdn.shopify.com/s/files/1/0627/8725/6536/products/19U07111_0.jpg';

  function fireGA4Event(name, params){
    if (typeof gtag !== 'function') return;
    gtag('event', name, Object.assign({
      event_callback: function(){},
      event_timeout: 1000,
      transport_type: 'beacon'
    }, params || {}));
  }

  /* ---------- picker data (verified active handles; price + image hydrate live below) ----------
     maxrun = manufacturer-rated max insulated trunk-line run (ft) at the base config.
     cooling = configurations the model line supports (Pro-Line offers air/water/remote as variants). */
  var MODELS = [
    {m:'Micro Matic Pro-Line MMPP4300', brand:'Micro Matic', btu:1700,  hp:'1/4', cooling:['air'],                 maxrun:75,  handle:'pro-line-power-pack-glycol-beer-cooling-system-1-700-btu-1-4-hp-1-pump-air-cooled'},
    {m:'Micro Matic Pro-Line MMPP4301', brand:'Micro Matic', btu:2300,  hp:'1/3', cooling:['air','water'],         maxrun:125, handle:'pro-line-beer-glycol-chiller-power-pack-2-300-btu-1-3-hp-1-pump-air-cooled'},
    {m:'Micro Matic Pro-Line MMPP4302', brand:'Micro Matic', btu:3600,  hp:'1/2', cooling:['air','water','remote'],maxrun:250, handle:'pro-line-glycol-beer-chiller-system-power-pack-3-600-btu-1-2-hp-1-pump-air-cooled'},
    {m:'Micro Matic Pro-Line MMPP4303', brand:'Micro Matic', btu:5100,  hp:'3/4', cooling:['air','water','remote'],maxrun:350, handle:'pro-line-3-4-hp-glycol-chiller-power-pack-5-100-btu-2-pumps-air-cooled'},
    {m:'Micro Matic Pro-Line MMPP4305', brand:'Micro Matic', btu:7250,  hp:'1',   cooling:['air','water','remote'],maxrun:500, handle:'pro-line-glycol-power-pack-commercial-beer-chiller-7-250-btu-1-hp-2-pumps-air-cooled'},
    {m:'Micro Matic Pro-Line MMPP4307', brand:'Micro Matic', btu:11500, hp:'1.5', cooling:['air','water','remote'],maxrun:825, handle:'pro-line-glycol-beer-cooling-system-power-pack-11-500-btu-1-1-2-hp'},
    {m:'UBC ChillPro 1150',             brand:'UBC Group',   btu:1150,  hp:'1/6', cooling:['air'],                 maxrun:60,  handle:'chillpro-1150-1-pump-19u07113'},
    {m:'UBC ChillPro 3200V',            brand:'UBC Group',   btu:3200,  hp:'1/3', cooling:['air'],                 maxrun:200, handle:'chillpro-3200v-1-pump-19u07105'},
    {m:'UBC ChillPro 5500',             brand:'UBC Group',   btu:5500,  hp:'1/2', cooling:['air'],                 maxrun:350, handle:'chillpro-5500-1-pump-19u07102'},
    {m:'UBC ChillPro 7500',             brand:'UBC Group',   btu:7500,  hp:'3/4', cooling:['air'],                 maxrun:500, handle:'chillpro-7500-1-pump-19u07109'},
    {m:'Perlick 4400 Quick Chill 1/3 HP', brand:'Perlick',  btu:2300,  hp:'1/3', cooling:['air'],                 maxrun:150, handle:'glycol-chiller-quickchill-1-3hp-4400-ser-19g09203'},
    {m:'Perlick 4410QC 1/2 HP',         brand:'Perlick',     btu:3800,  hp:'1/2', cooling:['air'],                 maxrun:300, handle:'glycol-chiller-quickchill-2-pump-1-2hp-4400-ser-19g09210'},
    {m:'Perlick 4414QC 3/4 HP',         brand:'Perlick',     btu:6000,  hp:'3/4', cooling:['air'],                 maxrun:450, handle:'glycol-chiller-quickchill-1-pump-3-4hp-4400-ser-19g09204'},
    {m:'Perlick 4420QC 1.5 HP',         brand:'Perlick',     btu:8000,  hp:'1.5', cooling:['air'],                 maxrun:825, handle:'glycol-chiller-quickchill-1-pump-1-5hp-4400-ser-19g09205'},
    {m:'BVL Eco-33Max',                 brand:'BVL Controls',btu:3300,  hp:'1/3', cooling:['air'],                 maxrun:200, handle:'glycol-chiller-eco-33max-1-pump-bvl-19b07101'}
  ];

  /* hydrate live price + image from Shopify so the picker never shows stale numbers */
  MODELS.forEach(function(md){
    md.price = md.price || 0;
    fetch('/products/' + md.handle + '.js').then(function(r){ return r.ok ? r.json() : null; }).then(function(p){
      if (!p) return;
      md.price = Math.round(p.price / 100);
      md.available = p.available;
      if (p.featured_image) md.img = p.featured_image;
    }).catch(function(){});
  });

  var STEPS = [
    {q:'How long is your longest beer line run?', help:'Run length from the keg cooler to the farthest tap. This is the #1 sizing factor for glycol.', key:'run', opts:[
      {v:50,  t:'Under 50 ft', d:'Short draw — small bar or single tower'},
      {v:150, t:'50–150 ft', d:'Typical single-bar long draw'},
      {v:300, t:'150–300 ft', d:'Multi-tower or remote keg room'},
      {v:500, t:'300–500 ft', d:'Large venue / stadium concourse'},
      {v:800, t:'500 ft +', d:'Ultra long-draw / multi-bar'}
    ]},
    {q:'How many beer lines (taps)?', help:'More taps means more glycol load — we add headroom for higher counts.', key:'taps', opts:[
      {v:4,  t:'1–4 taps', d:''},
      {v:8,  t:'5–8 taps', d:''},
      {v:16, t:'9–16 taps', d:''},
      {v:24, t:'16 + taps', d:''}
    ]},
    {q:'How should the power pack be cooled?', help:'Air is the default. Water holds output in hot/tight rooms; remote moves the compressor out of the space.', key:'cooling', opts:[
      {v:'air',    t:'Air-cooled', d:'Self-contained, lowest cost'},
      {v:'water',  t:'Water-cooled', d:'Hot or tight mechanical rooms'},
      {v:'remote', t:'Remote condensing', d:'Quiet space, compressor outside'},
      {v:'any',    t:'Not sure yet', d:'Show me the range'}
    ]}
  ];

  var state = {}, stepIdx = 0, started = false;
  function $(id){ return document.getElementById(id); }
  function coolLabel(c){ return c === 'water' ? 'Water-cooled' : c === 'remote' ? 'Remote' : 'Air-cooled'; }

  var stepsEl = $('picker-steps');
  if (stepsEl) {

    var renderStep = function(){
      var s = STEPS[stepIdx], prog = $('picker-progress'), html = '';
      for (var i = 0; i < STEPS.length; i++) html += '<span class="dot' + (i <= stepIdx ? ' done' : '') + '"></span>';
      html += '<span class="label">Step ' + (stepIdx + 1) + ' of ' + STEPS.length + '</span>';
      prog.innerHTML = html;
      $('picker-q').textContent = s.q;
      $('picker-help').textContent = s.help;
      var opts = '';
      s.opts.forEach(function(o, i){
        opts += '<button type="button" class="hb-collection-v2-picker-opt" data-i="' + i + '"><span class="t">' + o.t + '</span>' + (o.d ? '<span class="d">' + o.d + '</span>' : '') + '</button>';
      });
      $('picker-opts').innerHTML = opts;
      $('picker-back').hidden = stepIdx === 0;
      var calc = $('picker-calc');
      if (s.key === 'cooling' && state.run) {
        calc.innerHTML = 'Sizing for a <strong>' + state.run + ' ft</strong> run' + (state.taps ? ' &middot; <strong>' + (state.taps === 24 ? '16+' : (state.taps === 16 ? '9–16' : (state.taps === 8 ? '5–8' : '1–4'))) + ' taps</strong>' : '');
        calc.classList.add('show');
      } else {
        calc.classList.remove('show');
      }
      $('picker-opts').querySelectorAll('button').forEach(function(btn){
        btn.addEventListener('click', function(){ pick(s, parseInt(btn.dataset.i, 10)); });
      });
    };

    var pick = function(s, i){
      var o = s.opts[i];
      if (!started) { started = true; fireGA4Event('picker_start'); }
      state[s.key] = o.v;
      stepIdx++;
      fireGA4Event('picker_step_' + stepIdx);
      if (stepIdx >= STEPS.length) { showResults(); } else { renderStep(); }
    };

    var showResults = function(){
      var run = state.run || 150;
      var need = run;
      if (state.taps >= 16) need = Math.round(run * 1.5);
      else if (state.taps >= 9) need = Math.round(run * 1.25);
      var cool = state.cooling && state.cooling !== 'any' ? state.cooling : null;

      var pool = MODELS.filter(function(md){ return md.maxrun >= need; });
      if (cool) {
        var pref = pool.filter(function(md){ return md.cooling.indexOf(cool) !== -1; });
        if (pref.length) pool = pref;
      }
      var matches = pool.sort(function(a, b){ return a.maxrun - b.maxrun; }).slice(0, 3);
      if (!matches.length) {
        matches = MODELS.slice().sort(function(a, b){ return Math.abs(a.maxrun - need) - Math.abs(b.maxrun - need); }).slice(0, 3);
      }

      stepsEl.style.display = 'none';
      var r = $('picker-results');
      r.classList.add('show');
      $('picker-results-sub').textContent = 'Sized for a ' + run + ' ft run' + (cool ? ' · ' + coolLabel(cool) : '') + '. Estimate only — confirm the spec with a specialist.';
      var html = '';
      matches.forEach(function(md, i){
        var price = md.price ? '$' + md.price.toLocaleString() : '';
        html += '<div class="hb-collection-v2-result-card' + (i === 0 ? ' best' : '') + '">'
          + (i === 0 ? '<span class="hb-collection-v2-result-badge">Best match</span>' : '')
          + '<div class="hb-collection-v2-result-img"><img src="' + (md.img || DEFAULT_IMG) + '" alt="' + md.m + ' glycol power pack" loading="lazy" width="240" height="240"></div>'
          + '<div><span class="hb-collection-v2-result-series">' + md.brand + '</span><h4 class="hb-collection-v2-result-model">' + md.m + '</h4></div>'
          + '<div class="hb-collection-v2-result-specs">'
          + '<span>Cooling <b>' + md.btu.toLocaleString() + ' BTU</b></span>'
          + '<span>Compressor <b>' + md.hp + ' HP</b></span>'
          + '<span>Max run <b>up to ' + md.maxrun + ' ft</b></span>'
          + '<span>Config <b>' + (md.cooling.length > 1 ? 'air / water / remote' : 'air-cooled') + '</b></span>'
          + '</div>'
          + '<div style="display:flex;align-items:baseline;gap:8px;flex-wrap:wrap">' + (price ? '<span class="hb-collection-v2-result-price">' + price + '</span>' : '') + WEBPRICE_HTML + '<span class="hb-collection-v2-result-stock">✓ In stock</span></div>'
          + '<div class="hb-collection-v2-result-ctas">'
          + '<a href="/products/' + md.handle + '" class="hb-collection-v2-btn-primary" data-ga4="picker_result_view_product" data-model="' + md.m + '">View chiller</a>'
          + '<button type="button" class="hb-collection-v2-btn-secondary" data-open-quote data-ga4="picker_result_quote" data-model="' + md.m + '">Get a quote</button>'
          + '</div></div>';
      });
      $('result-cards').innerHTML = html;
      fireGA4Event('picker_result', {run_ft: run, taps: state.taps, cooling: state.cooling});
      var sc = $('sticky-cta');
      if (sc) { sc.textContent = 'Your matches ↑'; }
      bindAnchors($('result-cards'));
      $('result-cards').querySelectorAll('[data-ga4]').forEach(function(el){
        el.addEventListener('click', function(){ fireGA4Event(el.dataset.ga4, {model: el.dataset.model}); });
      });
    };

    $('picker-back').addEventListener('click', function(){ if (stepIdx > 0) { stepIdx--; renderStep(); } });
    $('picker-restart').addEventListener('click', function(){
      state = {}; stepIdx = 0; started = false;
      $('picker-results').classList.remove('show');
      stepsEl.style.display = '';
      var sc = $('sticky-cta');
      if (sc) { sc.textContent = 'Find my glycol chiller →'; }
      renderStep();
    });
    renderStep();
  }

  /* ---------- FAQ accordion ---------- */
  root.querySelectorAll('.hb-collection-v2-acc-trigger').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.hb-collection-v2-acc-item');
      var body = item.querySelector('.hb-collection-v2-acc-body');
      var open = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      body.hidden = !open;
    });
  });

  /* ---------- sticky mobile bar ---------- */
  var hero = $('hero-primary-cta'), bar = $('sticky-bar'), picker = $('picker');
  if ('IntersectionObserver' in window && hero && bar && picker) {
    var heroVisible = true, pickerVisible = false;
    var update = function(){ bar.classList.toggle('is-visible', !heroVisible && !pickerVisible); };
    new IntersectionObserver(function(e){ heroVisible = e[0].isIntersecting; update(); }, {rootMargin: '0px'}).observe(hero);
    new IntersectionObserver(function(e){ pickerVisible = e[0].isIntersecting; update(); }, {rootMargin: '-80px 0px 0px 0px'}).observe(picker);
  }

  /* ---------- capture form (Klaviyo client API; goes live when list ID is set in theme editor) ---------- */
  var capForm = $('capture-form');
  if (capForm) {
    capForm.addEventListener('submit', function(ev){
      ev.preventDefault();
      var email = capForm.querySelector('input[type="email"]').value.trim();
      if (!email) return;
      var companyId = capForm.dataset.klaviyoCompanyId, listId = capForm.dataset.klaviyoListId;
      var done = function(msg){
        capForm.style.display = 'none';
        var s = $('capture-success');
        s.textContent = msg;
        s.classList.add('show');
      };
      fireGA4Event('hub_capture_submit');
      if (companyId && listId) {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'revision': '2024-10-15'},
          body: JSON.stringify({data: {type: 'subscription', attributes: {custom_source: 'glycol-hub', profile: {data: {type: 'profile', attributes: {email: email}}}}, relationships: {list: {data: {type: 'list', id: listId}}}}})
        }).then(function(r){
          done(r.status === 202 ? '✓ Check your inbox — the guide is on its way.' : 'Something went wrong — email help@howdybrewer.com and we’ll send it directly.');
        }).catch(function(){
          done('Something went wrong — email help@howdybrewer.com and we’ll send it directly.');
        });
      } else {
        done('Guide delivery goes live shortly — email help@howdybrewer.com and we’ll send it to you today.');
      }
    });
  }

  /* ---------- Web Price tooltips (tap support) ---------- */
  function closeWebprices(except){
    document.querySelectorAll('.hb-collection-v2-webprice.open').forEach(function(w){
      if (w !== except) w.classList.remove('open');
    });
  }
  function flipWebprice(w){
    var r = w.getBoundingClientRect();
    w.classList.toggle('flip', r.left + 280 > window.innerWidth);
  }
  document.addEventListener('mouseover', function(e){
    var w = e.target.closest('.hb-collection-v2-webprice');
    if (w) flipWebprice(w);
  });
  document.addEventListener('click', function(e){
    var q = e.target.closest('.hb-collection-v2-webprice-q');
    if (q) {
      e.preventDefault();
      e.stopPropagation();
      var w = q.closest('.hb-collection-v2-webprice');
      var opening = !w.classList.contains('open');
      closeWebprices(w);
      flipWebprice(w);
      w.classList.toggle('open');
      if (opening) fireGA4Event('hub_webprice_open');
      return;
    }
    if (e.target.closest('[data-open-quote]')) {
      closeWebprices();
      return; /* let the global quote-drawer handler take it */
    }
    if (!e.target.closest('.hb-collection-v2-webprice')) closeWebprices();
  });

  /* ---------- GA4 on static CTAs ---------- */
  root.querySelectorAll('[data-ga4-static]').forEach(function(el){
    el.addEventListener('click', function(){
      fireGA4Event(el.dataset.ga4Static, el.dataset.handle ? {handle: el.dataset.handle, position: el.dataset.position} : {});
    });
  });

  /* ---------- smooth scroll for in-page anchors ---------- */
  function bindAnchors(scope){
    (scope || root).querySelectorAll('a[href^="#"]').forEach(function(a){
      if (a.dataset.bound) return;
      a.dataset.bound = '1';
      a.addEventListener('click', function(ev){
        var id = a.getAttribute('href');
        if (id.length < 2) return;
        var t = document.getElementById(id.slice(1));
        if (t) { ev.preventDefault(); t.scrollIntoView({behavior: 'smooth'}); }
      });
    });
  }
  bindAnchors();
  var sticky = $('sticky-bar');
  if (sticky) bindAnchors(sticky);
})();
